const semanticRetroLight = {
    bg: {
        default: '#FFFFFF',
        neutral: '#FCFDFD',
    },
    fill: {
        default: '#FFFFFF',
        neutral: '#686F79',
        primary: '#0D6BDE',
        error: '#DA1639',
        warning: '#B36200',
        success: '#247F40',
        complementary: '#FF5F0F',
        supplementary1: '#9053C2',
        supplementary2: '#007C7C',
        contrary: {
            transparent: '#0000006B', // #000000 42%
            subtler: {
                transparent: '#0000000A', // #000000 4%
            },
            subtle: {
                transparent: '#0000001F', // #000000 12%
            },
            strong: {
                transparent: '#0000008F', // #000000 56%
            },
        },
        blend: {
            transparent: '#FFFFFF54', // #FFFFFF 33%
            subtle: {
                transparent: '#FFFFFF1A', // #FFFFFF 10%
            },
            strong: {
                transparent: '#FFFFFF7A', // #FFFFFF 48%
            },
        },
        subtler: {
            neutral: '#F7F9FA',
            primary: '#F2F8FF',
            error: '#FFF2F5',
            warning: '#FFF9F2',
            success: '#F2FFF6',
            complementary: '#FFF7F2',
            supplementary1: '#F7F2FB',
            supplementary2: '#D4FCFB',
        },
        subtle: {
            neutral: '#F1F4F6',
            primary: '#F2F8FF',
            error: '#FFF2F5',
            warning: '#FFF9F2',
            success: '#F2FFF6',
            complementary: '#FFF7F2',
            supplementary1: '#F7F2FB',
            supplementary2: '#D4FCFB',
        },
        global: {
            primary: '#0D6BDE',
            error: '#DA1639',
            dark: {
                transparent: '#0000006B', // #000000 42%
            },
            light: {
                transparent: '#FFFFFF54', // #FFFFFF 33%
            },
            subtle: {
                dark: {
                    transparent: '#0000001F', // #000000 12%
                },
                light: {
                    transparent: '#FFFFFF1A', // #FFFFFF 10%
                },
            },
            strong: {
                dark: {
                    transparent: '#0000008F', // #000000 56%
                },
                light: {
                    transparent: '#FFFFFF7A', // #FFFFFF 48%
                },
            },
            success: '#247F40',
            supplementary1: '#9053C2',
            supplementary2: '#007C7C',
            supplementary3: '#2974A8',
            neutral: '#555B62',
            complementary: '#9D3B0F',
            warning: '#B36200',
        },
    },
    text: {
        neutral: '#686F79',
        primary: '#0D6BDE',
        error: '#DA1639',
        warning: '#B36200',
        success: '#247F40',
        complementary: '#CF4B0A',
        supplementary1: '#9053C2',
        supplementary2: '#007C7C',
        strong: {
            neutral: '#555B62',
            primary: '#2057B1',
            error: '#AF1E30',
            warning: '#884B0A',
            success: '#196830',
            complementary: '#9D3B0F',
            supplementary1: '#73439A',
            supplementary2: '#006462',
        },
        stronger: {
            neutral: '#2A2B2D',
            primary: '#1A2A52',
            error: '#54171A',
            warning: '#4D2D0E',
            success: '#123019',
            complementary: '#59260F',
            supplementary1: '#261735',
            supplementary2: '#002322',
        },
        global: {
            strong: {
                warning: '#884B0A',
            },
        },
        inverse: {
            neutral: '#F7F9FA',
            primary: '#F2F8FF',
            error: '#FFF2F5',
            warning: '#FFF9F2',
            success: '#F2FFF6',
            complementary: '#FFF7F2',
            supplementary1: '#FAF7FD',
            supplementary2: '#E9FEFD',
        },
    },
    icon: {
        neutral: '#8E9194',
        primary: '#3B90F7',
        error: '#FF2638',
        warning: '#FFD700',
        success: '#09A639',
        complementary: '#FF5500',
        supplementary1: '#AD75DA',
        supplementary2: '#009E9A',
        inverse: '#FFFFFF',
    },
    border: {
        neutral: '#939BA4',
        primary: '#4B96F1',
        error: '#FF6682',
        warning: '#C28030',
        success: '#48AD67',
        complementary: '#FF5F0F',
        supplementary1: '#AD75DA',
        supplementary2: '#009E9A',
        subtle: {
            neutral: '#DFE3E8',
            primary: '#A8CCF8',
            error: '#F6AAB8',
            warning: '#E1BD93',
            success: '#9ECEAD',
            complementary: '#FFAB81',
            supplementary1: '#EBDDF6',
            supplementary2: '#61F6F2',
        },
        strong: {
            neutral: '#555B62',
            primary: '#2057B1',
            error: '#AF1E30',
            warning: '#884B0A',
            success: '#196830',
            complementary: '#9D3B0F',
            supplementary1: '#73439A',
            supplementary2: '#006462',
        },
    },
    state: {
        hover: '#0000001F', // #000000 12%
        press: '#0000006B', // #000000 42%
        disable: '#ADB1B8',
        inactive: '#FFFFFF99', // #FFFFFF 60%
        neutral: {
            hover: '#5E646D',
            press: '#3E4349',
        },
        subtle: {
            disable: '#E6EBEF',
            neutral: {
                hover: '#6E76801F', // #6E7680 12%
                press: '#6E76806B', // #6E7680 42%
            },
            primary: {
                hover: '#0E72ED1F', // #0E72ED 12%
                press: '#0E72ED6B', // #0E72ED 42%
                disable: '#AACDF8',
            },
            error: {
                hover: '#E8173D1F', // #E8173D 12%
                press: '#E8173D6B', // #E8173D 42%
                disable: '#F7BAC6',
            },
            warning: {
                hover: '#B362001F', // #B36200 12%
                press: '#B362006B', // #B36200 42%
            },
            success: {
                hover: '#2685431F', // #268543 12%
                press: '#2685436B', // #268543 42%
            },
            complementary: {
                hover: '#CF4B0A1F', // #CF4B0A 12%
                press: '#CF4B0A6B', // #CF4B0A 42%
            },
            supplementary1: {
                hover: '#9053C21F', // #9053C2 12%
                press: '#9053C26B', // #9053C2 42%
            },
            supplementary2: {
                hover: '#007C7C1F', // #007C7C 12%
                press: '#007C7C6B', // #007C7C 42%
            },
        },
        primary: {
            hover: '#0C60C8',
            press: '#084085',
        },
        error: {
            hover: '#C41434',
            press: '#830D23',
        },
        warning: {
            hover: '#A15800',
            press: '#6C3B00',
        },
        success: {
            hover: '#207239',
            press: '#164C26',
        },
        complementary: {
            hover: '#BA4409',
            press: '#7C2D06',
        },
        supplementary1: {
            hover: '#8341B8',
            press: '#572C7B',
        },
        supplementary2: {
            hover: '#007070',
            press: '#004A4A',
        },
        contrary: {
            subtle: {
                transparent: {
                    hover: '#0000003D', // #000000 24%
                    press: '#0000007A', // #000000 48%
                },
            },
            subtler: {
                transparent: {
                    hover: '#00000014', // #000000 8%
                    press: '#0000003D', // #000000 24%
                },
            },
            transparent: {
                hover: '#0000007A', // #000000 48%
                press: '#000000CC', // #000000 80%
            },
            strong: {
                transparent: {
                    hover: '#000000A3', // #000000 64%
                    press: '#000000F5', // #000000 96%
                },
            },
        },
        global: {
            disable: '#ADB1B8',
            dark: {
                transparent: {
                    hover: '#0000007A', // #000000 48%
                    press: '#000000CC', // #000000 80%
                },
            },
            light: {
                transparent: {
                    hover: '#FFFFFFA3', // #FFFFFF 64%
                    press: '#0000003D', // #000000 24%
                },
            },
            subtle: {
                dark: {
                    transparent: {
                        hover: '#0000003D', // #000000 24%
                        press: '#0000007A', // #000000 48%
                    },
                },
                light: {
                    transparent: {
                        hover: '#FFFFFF7A', // #FFFFFF 48%
                        press: '#00000052', // #000000 32%
                    },
                },
            },
            strong: {
                dark: {
                    transparent: {
                        hover: '#000000A3', // #000000 64%
                        press: '#000000F5', // #000000 96%
                    },
                },
                light: {
                    transparent: {
                        hover: '#FFFFFFCC', // #FFFFFF 80%
                        press: '#00000029', // #000000 16%
                    },
                },
            },
        },
    },
    inverse: {
        default: '#FFFFFF',
        neutral: '#F7F9FA',
        global: {
            default: '#FFFFFF',
        },
    },
    underlay: {
        dark: '#00000033', // #000000 20%
        default: '#FFFFFFCC', // #FFFFFF 80%
        dropShadow: '#00000014', // #000000 8%
    },
    component: {
        input: {
            border: '#C1C6CE',
        },
    },
};
export default semanticRetroLight;
